import gql from 'graphql-tag';

import remoteItemPermissionFragment from '../fragments/remoteItemPermissionFragment';

export default gql`
  query remoteItemPermissions(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    remoteItemPermissions(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...remoteItemPermissionFragment
    }
  }
  ${remoteItemPermissionFragment}
`;
